<template>
  <component :is="currentView" />
</template>

<script>
import config from '@/config'

export default {
  name: 'VAccount',

  components: {
    [config.groups.ADMIN]: () => import(/* webpackChunkName: "v-account-admin" */ '@/views/VAccount/VAccountAdmin'),
    [config.groups.COACH]: () => import(/* webpackChunkName: "v-account-coach" */ '@/views/VAccount/VAccountCoach'),
    [config.groups.COACHEE]: () => import(/* webpackChunkName: "v-account-coachee" */ '@/views/VAccount/VAccountCoachee')
  },

  computed: {
    currentView () {
      // If the user logs out while on account route, the store will be cleared
      // prior to route change to login. This leads to a _public_ user group
      // which has no corresponding component.
      if (this.$is([config.groups.ADMIN, config.groups.COACH, config.groups.COACHEE])) {
        return this.$store.state.user.meta.group
      }

      return undefined
    }
  }
}
</script>
